// The glyphs Blueprint's controls draw: strokes on a 16-unit grid in the current colour. A glyph has no
// stylesheet of its own: the component that holds it sizes it and sets its stroke from its own tokens
// (IconButton: --iconbtn-glyph, --iconbtn-stroke), through the class it passes.
const PATHS = {
  'chevron-left': 'M10 3.5 5.5 8l4.5 4.5',
  'chevron-right': 'M6 3.5 10.5 8 6 12.5',
  close: 'M3.5 3.5l9 9M12.5 3.5l-9 9',
  filter: 'M2 3h12L9.5 8.5V13l-3-1.5v-3z',
  // lanes gathered under division headings: two headings, each with a row hung under it from its start
  // (Amir, 26 Oct: the old three lines and a stroke read as a table, not as grouping)
  group: 'M2 2.5h12M4 2.5V6h10M2 9.5h12M4 9.5V13h10',
  plus: 'M8 3v10M3 8h10',
  'rows-comfortable': 'M2 2.5h12v4.5H2zM2 9h12v4.5H2z',
  'rows-compact': 'M2 2.5h12v2.5H2zM2 6.75h12v2.5H2zM2 11h12v2.5H2z',
  // the job page round: an area's chevron, history's kinds, the call player, a photo that didn't load
  'chevron-down': 'M3.5 6 8 10.5 12.5 6',
  'chevron-up': 'M3.5 10 8 5.5 12.5 10',
  check: 'M3.5 8.5l3 3 6-7',
  search: 'M7 2.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9zM10.5 10.5 14 14',
  phone:
    'M3 2h3l1.5 3.5L5.5 6.8a8 8 0 0 0 3.7 3.7l1.3-2L14 10v3a1 1 0 0 1-1 1A11.5 11.5 0 0 1 2 3a1 1 0 0 1 1-1z',
  message: 'M2 2.5h12v8.5H6l-4 3z',
  note: 'M3.5 1.5h6.5l2.5 2.5v10.5h-9zM10 1.5V4h2.5M5.5 8h5M5.5 11h3.5',
  pin: 'M8 14.5S3 10 3 6.5a5 5 0 0 1 10 0c0 3.5-5 8-5 8zM8 4.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4z',
  camera: 'M1.5 4.5h3l1.5-2h4l1.5 2h3v9h-13zM8 6.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5z',
  form: 'M3.5 1.5h9v13h-9zM5.5 5h5M5.5 8h5M5.5 11h2.5',
  money: 'M1.5 4h13v8h-13zM8 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4z',
  estimate: 'M2.5 2.5h11v11h-11zM5 6h6M5 8.5h6M5 11h3',
  parts: 'M2 4.5 8 2l6 2.5v7L8 14l-6-2.5zM2 4.5 8 7l6-2.5M8 7v7',
  pencil: 'M2.5 13.5h2.5l8-8-2.5-2.5-8 8z',
  calendar: 'M2 3.5h12v10.5H2zM2 6.5h12M5 1.5v3M11 1.5v3',
  play: 'M5 3v10l8-5z',
  pause: 'M5.5 3v10M10.5 3v10',
  'image-off': 'M1.5 3h13v10h-13zM1.5 11.5 6 7.5l2.5 2.5M11 6.5h.01M2 1.5l12 13',
  // the board's arranging (26 Oct): ⋮⋮, a handle to drag or open a menu from
  grip: 'M5.5 3h.5M10 3h.5M5.5 8h.5M10 8h.5M5.5 13h.5M10 13h.5',
} as const;

export type GlyphName = keyof typeof PATHS;
export const GLYPHS = Object.keys(PATHS) as GlyphName[];

export function Glyph({ name, className }: { name: GlyphName; className: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeLinecap="square"
      strokeLinejoin="miter"
      aria-hidden="true"
      focusable="false"
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
